
import {FC, HTMLAttributes, Image} from 'external/react'
import getImage from 'resources/assets/index'

type AssetImageProps = {
    className?: string
    imageClass?: string
    alt?: string
    src: string
    containerProps?: HTMLAttributes<HTMLDivElement>
    imageProps?: HTMLAttributes<HTMLImageElement>
}

const AssetImage : FC<AssetImageProps> = props => {
    const {containerProps = {}, className, alt, imageProps = {}, imageClass = 'fill'} = props
    const src = getImage(`/${props.src}`)
    return (
        <div {...containerProps} className={className} >
            <Image {...imageProps} src={src} alt={alt} className={imageClass} />
        </div>
    )
}

export {AssetImage as default}